import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import RainModalContent from "./content";
import SvgIcon from "../../../components/svg-icon";
import {useSelector} from "react-redux";

const RainModal = props => {

    const {handleClose} = props

    useEffect(() => {

        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('wallet-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'


        return () => {
            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [])

    const {t} = useTranslation()


    return (
        <div
            className="modal fade"
            id="wallet-modal"
            tabIndex={-1}
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title">{t('rain.title')}</h6>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>

                        <RainModalContent/>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default RainModal
